import * as React from "react";
import { BraQuizResults } from "@lululemon/ufs-shared";
import { publicConfig } from "../../util/public-config";

const BraQuizResultsAdapter = (props) => {
  const { host, apiHost, proxyApiHost = "", links } = publicConfig;

  return (
    <BraQuizResults
      host={host}
      apiHost={apiHost}
      proxyApiHost={proxyApiHost}
      links={links}
      {...props}
    />
  );
};

export default BraQuizResultsAdapter;
